/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Label_Cancelled_AtInputs */

const vi_sl_detail_label_cancelled_at = /** @type {(inputs: Sl_Detail_Label_Cancelled_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hủy`)
};

/**

* @param {Sl_Detail_Label_Cancelled_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_label_cancelled_at = /** @type {((inputs?: Sl_Detail_Label_Cancelled_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Label_Cancelled_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_label_cancelled_at(inputs)
});